import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import * as api from './gst-invoices.api';

import type { MarkGstInvoicePaidRequest } from '@utazzo/shared';

const REGISTER_KEY = ['reports', 'gst-output-register'] as const;

const messageOf = (err: unknown, fallback: string): string => {
  if (err && typeof err === 'object') {
    const e = err as { message?: unknown; details?: { message?: unknown } };
    if (e.details && typeof e.details.message === 'string') return e.details.message;
    if (typeof e.message === 'string') return e.message;
  }
  return fallback;
};

/** Set/clear the per-invoice GST paid flag. */
export const useMarkGstInvoicePaid = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ invoiceId, body }: { invoiceId: string; body: MarkGstInvoicePaidRequest }) =>
      api.markGstInvoicePaid(invoiceId, body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: REGISTER_KEY });
    },
    onError: (err: unknown) => toast.error(messageOf(err, 'Failed to update the GST paid status')),
  });
};
